// removed by extract-text-webpack-plugin
module.exports = {"UploadPhotoPopup":"style__UploadPhotoPopup___2K3LB","UploadPhotoPopupHeader":"style__UploadPhotoPopupHeader___2cn3L","cropContainer":"style__cropContainer___4VfWX","buttons":"style__buttons___20xyb","saveButton":"style__saveButton___20aih"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Profile/AvatarUploader/style.scss
// module id = 1456
// module chunks = 0